import { Image, Row, Col, Container, Form, Button } from 'react-bootstrap';
import MainNav from '../Global/MainNav';
import Socials from '../Utils/socials';

const Contact = () => {
  return (
    <section
      id="contact"
      className="contact">
      <Container className='d-flex flex-column justify-content-center align-items-center'>
        <h1 className="text-white">Get In Touch!</h1>
        <Socials />
      </Container>
    </section>
  );
};

export default Contact;
